export function init() {
  const baseclass = 'blog__header';

  if (document.querySelector(`.${baseclass}--has-thumbs`)) {
    const container = document.querySelector(`.${baseclass}-right`);
    const divs = container.querySelectorAll(`.${baseclass}-right figure`);
    const slides = document.querySelectorAll(`.${baseclass}-left >*`);

    let slideChangeTime = 3000;
    let currentIndex = 0;
    let timer;

    if (document.querySelector(`.${baseclass}`).hasAttribute('data-timer')) {
      slideChangeTime = document.querySelector(`.${baseclass}`).getAttribute('data-timer') * 1000;
    }

    const setActiveDiv = () => {
      divs.forEach(div => div.classList.remove('is-active'));

      if (divs[currentIndex] === undefined) {
        currentIndex = 1;
      }

      divs[currentIndex].classList.add('is-active');

      slides.forEach(div => div.classList.remove('is-active'));
      slides[currentIndex].classList.add('is-active');
    };

    const goToNextDiv = () => {
      currentIndex++;

      if (currentIndex === divs.length || currentIndex === -1) {
        currentIndex = 0;
      }

      setActiveDiv();

      clearInterval(timer);
      timer = setInterval(goToNextDiv, slideChangeTime);
    };

    divs.forEach(div => {
      div.addEventListener('click', () => {
        document.querySelector('.blog__header-right figure.is-active').classList.remove('is-active');
        div.classList.add('is-active');
        currentIndex = div.getAttribute('data-slide');

        if (currentIndex === -1) {
          currentIndex = 0;
        }

        slides.forEach(div => div.classList.remove('is-active'));
        slides[currentIndex].classList.add('is-active');

        clearInterval(timer);
        timer = setInterval(goToNextDiv, slideChangeTime);
      });
    });

    setActiveDiv();
    timer = setInterval(goToNextDiv, slideChangeTime);
  }
}

export default {
  init,
};
